module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.isBallArr), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('transition', {
      attrs: {
        "name": "ball"
      },
      on: {
        "before-enter": _vm.beforeDrop,
        "enter": _vm.dropping,
        "after-enter": _vm.afterDrop
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.show),
        expression: "item.show"
      }],
      ref: "ball",
      refInFor: true,
      staticClass: "ball-box"
    }, [_c('transition', {
      attrs: {
        "name": "zhuan"
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.show),
        expression: "item.show"
      }],
      attrs: {
        "src": _vm.classifyAnimate.headPic,
        "alt": ""
      }
    })])], 1)])], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ac42514"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Classify/AnimateAddShop.vue
// module id = 559
// module chunks = 0